import React from 'react';
import Alert from '../../../../../components/Alert/Alert';
import AlertSeverity from '../../../../../ui/shared/severity/AlertSeverity';

const DetainedAdditionalSteps: React.FunctionComponent = () => (
  <Alert
    title="Étapes suivantes"
    severity={AlertSeverity.INFO}
    showIcon
    message={
      <ul>
        <li>SVP ajouter le numéro de détenu & l’adresse du centre de détention ou joindre photo carte prisonnier</li>

        <li>N.B. Si le patient a un NAM admissible il doit être facturé à la RAMQ</li>
      </ul>
    }
  />
);

export default DetainedAdditionalSteps;
